/**
 * Created by Ninghai on 2017/12/22.
 */

import {javaServiceUrl3, serviceUrl} from '../utils/constant'
//引入javaBeta版地址
import { javaServiceUrl } from '../utils/constant'
import { javaServiceUrl1 } from '../utils/constant'
export const TOKEN_API_URL = serviceUrl + '/api/public/user/token'
// export const LOGIN_API_URL = serviceUrl + '/api/public/user/login'
export const LOGIN_API_URL = javaServiceUrl + '/user/login'

//原python接口
// export const SIGNUP_API_URL = serviceUrl + '/api/public/user/signup'
export const SIGNUP_API_URL = javaServiceUrl + '/user/registe'
export const SIGNUP_API1_URL = javaServiceUrl1 + '/apiPermission/registe'
export const VERIFY_CODE_IMG_API_URL = serviceUrl + '/api/public/user/photocode/'
export const RESET_PASSWORD_API_URL = serviceUrl + '/api/public/user/resetpassword'
export const RECOVER_PASSWORD_API_URL = serviceUrl + '/api/public/user/recoverpassword'
export const LOGOUT_API_URL = javaServiceUrl + '/user/logout'

// 原python 重置密码接口
// export const REST_PASSWORD_API_URL = serviceUrl + '/api/private/user/changepassword'
export const REST_PASSWORD_API_URL = javaServiceUrl + '/user/updatePassword'
//原python获取用户信息接口
// export const GET_USER_INFOR_API_URL = serviceUrl + '/api/private/user/info'
export const GET_USER_INFOR_API_URL = javaServiceUrl + '/user/getInformation'
//原python用户信息 保存修改
// export const UPDATE_USER_INFO = serviceUrl + '/api/private/user/update'
export const UPDATE_USER_INFO = javaServiceUrl + '/user/updateInformation'
export const USER_APPLY_DATA_API_URL = serviceUrl + '/api/private/user/applydata'
export const USER_APPLY_DATA_LIST_COUNT_API_URL = serviceUrl + '/api/private/user/applydata/count'
export const USER_APPLY_DATA_LIST_API_URL = serviceUrl + '/api/private/user/applydata/list'

export const ENTERPRISE_SUMMARY_API_URL = serviceUrl + '/api/enterprise/sale/info'

// companyList productList
export const COMPANY_LIST_API_URL = serviceUrl + '/api/private/enterprise/info/list'

// A股相关接口
export const MENU_LIST_DATA_API_URL = serviceUrl + '/api/industry/mapping'  // 菜单栏
export const INDUSTRY_DATA_API_URL = serviceUrl + '/api/industry/sale/info'  // 行业数据
export const ENTERPRISE_DATA_API_URL = serviceUrl + '/api/enterprise/sale/info' // 企业(公司)数据
export const BRAND_DATA_API_URL = serviceUrl + '/api/enterprise/sale/info' // 品牌数据
export const PRODUCT_DATA_API_URL = serviceUrl + '/api/product/sale/info' // 具体产品数据
export const ASHARE_LATEST_RECORD_DATE_API_URL = serviceUrl + '/api'  // 获取产品最新记录日期
export const ASHARE_MENU_MATRIX_LOOCK = serviceUrl + '/api/AShare/access/matrix'
export const ASHARE_ORDER_API_URL = serviceUrl + '/api/AShare/private/user/order'

export const COMPANY_SUM_INFO_URL = serviceUrl + '/api/enterprise/ocs/info'

// 未上市公司
export const UNLISTED_COMPANY_DETAIL_INFO_API_URL = serviceUrl + '/api/private/enterprise/info'
export const UNLISTED_COMPANY_DETAIL_DATA_API_URL = serviceUrl + '/api/private/enterprise/data'
export const UNLISTED_COMPANY_DETAIL_DATALIST_API_URL = serviceUrl + '/api/private/enterprise/data/list'
export const UNLISTED_COMPANY_PAY_INFO_API_URL = serviceUrl + '/api/private/enterprise/abstract'
export const ORDER_API_URL = serviceUrl + '/api/private/user/order'

// 中概股
export const LATEST_RECORD_DATE_API_URL = serviceUrl + '/api/enterprise/latestRecordDate'
export const OCS_COMPANY_SUMMARY_URL = serviceUrl + '/api/enterprise/@id/summary'
export const OCS_COMPANY_COMPUTED_URL = serviceUrl + '/api/enterprise/@id/computed';
export const TMALL_JD_DATA_URL = serviceUrl + '/api/china/concept/sales'
export const MOMO_DATA_URL = serviceUrl + '/api/@id/@type'
export const KL_YANXUAN_DATA_URL = serviceUrl + '/api/private/enterprise/ocs/rangeData'
export const YY_HUYA_DATA_URL = serviceUrl + '/api/enterprise/@id'
export const OCS_PURCHASE_DATA_URL = serviceUrl + '/api/ocs/purchase';

// 支付接口
export const CHARGE_API_URL = serviceUrl + '/api/private/user/charge'
export const USER_WEIXIN_PAY_API_URL = serviceUrl + '/api/private/user/weixinqr'

// 客服 用户反馈
export const VISITOR_FEEDBACK_API_URL = serviceUrl + '/api/'

// 情绪指数
export const SENTIMENT_LIST_API_URL = serviceUrl + '/api/sentiment/optimum'
export const SENTIMENT_GROWTH_LIST_API_URL = serviceUrl + '/api/sentiment/growth'
export const HOT_LIST_API_URL = serviceUrl + '/api/hot/optimum '
export const HOT_GROWTH_LIST_API_URL = serviceUrl + '/api/hot/growth'
export const STOCK_SENTIMENT_API_URL = serviceUrl + '/api/enterprise/sentiment'
export const STOCK_HOT_API_URL = serviceUrl + '/api/enterprise/hot'

// 茅台数据
export const MAOTAI_DATA_API_URL = serviceUrl + '/api/Maotai/sale/info'

//模糊搜索
export const vagueSeaechUrl = javaServiceUrl + '/global/searchIndustryOrCompany'
//天维度数据
export const newCompanyInfo = javaServiceUrl + '/aShares/company/info'
//java公司某个单品的销售
export const newCategoryInfo = javaServiceUrl + '/aShares/category/info'
//java接口获取A股、中概股、未上市公司列表（根据参数不同）
export const newCompanyListMuenu = javaServiceUrl + '/global/menu'
//java接口获取A股行业数据
export const newIndustryMessage = javaServiceUrl + '/aShares/industry/info'
//中概股拼多多
export const pinduoduoUrl = serviceUrl + '/api/china/concept/sales'

/**
 * 情绪因子接口
 */
 //获取参数
 export const emotionParameter = javaServiceUrl + '/sentiment/info'
 //获取详细数据
 export const emotionDetailsUrl = javaServiceUrl + '/sentiment/query'

 /**
  * 电商标准化
 */
export const retailersUrl = javaServiceUrl + '/ccs/eCommerce/query'
/**
 * 直播标准化
*/
export const liveUrl = javaServiceUrl + '/ccs/live/query'
//情绪因子和中概下载
export const downloadUrl = javaServiceUrl + '/global/download'
//中概股获取最薪数据
export const topLiveUrl = javaServiceUrl + '/ccs/info';

//数据下载
export const dataDownURL = javaServiceUrl + '/global/filesList';

//品牌馆
export const dataBrandUrl = javaServiceUrl + '/ccs/eCommerce/ppgQuery';

//首页 数据快讯
export const dataExpressUrl = javaServiceUrl + '/other/function/news';

//15万天猫------start
//左侧导航
export const dataInfoUrl = javaServiceUrl + '/other/function/tmall/level1info';
//列表
export const dataListUrl = javaServiceUrl + '/other/function/tmall/info';
//下拉菜单
export const dataSelectUrl = javaServiceUrl + '/other/function/tmall/rid2bid';

// chatGPT地址

//代码
export const chatGPTUrl = javaServiceUrl3+'/code/code_bbt';
//通用
export const chatGPTUrl1 = javaServiceUrl3+'/chat/code_bbt';
//test3
export const chatGPTUrl3 = javaServiceUrl3+'/test3/code_bbt';
//tets4
export const chatGPTUrl4 = javaServiceUrl3+'/test4/code_bbt';
//15万天猫------end



// WEBPACK FOOTER //
// ./src/services/serviceConstant.js